/**
 * @generated SignedSource<<e63387a00c43e313acd02bb512e3b2a5>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EditCompanyScheduleVisibility",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "CompanyScheduleSettings",
                "kind": "LinkedField",
                "name": "scheduleSettings",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "viewAccessUntil",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Company",
        "abstractKey": null
    };
})();
node.hash = "c63cfb353d061317179963205b120daf";
export default node;
